import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useChat } from '../../context/chatContext';

const ActiveDatasetsDisplay: React.FC = () => {
  const { activeDatasets } = useChat();

  if (!activeDatasets || activeDatasets.length === 0) {
    return null; // Don't render the component if no datasets are active
  }

  return (
    <Box sx={{ p: 2, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
      <Typography variant="body2" sx={{ mr: 1, color: 'text.secondary', fontWeight: 'bold' }}>
        Active Context:
      </Typography>
      {activeDatasets.map((dataset) => (
        <Chip key={dataset} label={dataset} size="small" variant="outlined" color="primary" />
      ))}
    </Box>
  );
};

export default ActiveDatasetsDisplay;